import RegisztracioFejlec from './RegisztracioFejlec';
import NevMegadas from './NevMegadas';
import { vazlatOlvasas, vazlatIras, vazlatTorles } from '../../vazlat';
import React,  { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate} from 'react-router-dom';
import {Row, Col, Modal, InputGroup, Form, Accordion, Container, Button, Card, ListGroup, ListGroupItem} from 'react-bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import VendegLista from './regisztracio/VendegLista';

import JegyLista from './regisztracio/JegyLista';

import SzamlazasiAdatokDisplay from './regisztracio/SzamlazasiAdatokDisplay';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

export default function Regisztracio({betoltottMegrendelesData, felhasznalo, setFelhasznalo, ...props}) {
    const [vazlatBetoltve, setVazlatBetoltve] = useState(false);
    const [rendezveny, setRendezveny] = useState(undefined);
    const [jegyek_mentve, setJegyek_mentve] = useState([]);
    const [fizetes_mentes_gomb_helyett_karika, setFizetes_mentes_gomb_helyett_karika] = useState(false);
    const [adat1Text, setAdat1Text] = useState("");
    const [adat2Text, setAdat2Text] = useState("");
    const [adat3Text, setAdat3Text] = useState("");
    

    let navigate = useNavigate();
    //let location = useLocation();

    useEffect(() => {
        /*
        console.log("esuEffect regiszt")
        console.log(betoltottMegrendelesData);
        */

    }, [fizetes_mentes_gomb_helyett_karika])

    // A rendezvény betöltése. Név nélkül még nem lehet regisztrálni: addig a név bekérése látszik, és a
    // rendezvényt a név megadása után töltjük be.
    const nevMegvan = felhasznalo.Nev !== '';
    useEffect(() => {
        if (!nevMegvan) {
            return;
        }
        props.callAPI("General.getRendezveny", {rendezvenyID: props.rendezvenyID}, function(resp){
            setRendezveny(resp.data.rendezveny)
            if (betoltottMegrendelesData != undefined) {
                // mentett (még nem fizetett) megrendelés módosítása
                setJegyek_mentve(betoltottMegrendelesData.jegyek)
            }else{
                // még nem mentett regisztráció: a böngészőben tárolt vázlat visszaállítása (frissítés, Vissza)
                const vazlat = vazlatOlvasas(props.rendezvenyID, felhasznalo.Id);
                if (vazlat !== null){
                    setJegyek_mentve(vazlat.jegyek);
                    setAdat1Text(vazlat.adatok[0] || "");
                    setAdat2Text(vazlat.adatok[1] || "");
                    setAdat3Text(vazlat.adatok[2] || "");
                }
            }
            setVazlatBetoltve(true);
        }, function(){
            // nem található / nem látható rendezvény: vissza a listára
            navigate('/rendezvenyek', {replace: true});
        });
    }, [nevMegvan])

    // A vázlat mentése minden módosításkor (csak a még nem mentett regisztrációnál)
    useEffect(() => {
        if (vazlatBetoltve && betoltottMegrendelesData == undefined){
            vazlatIras(props.rendezvenyID, felhasznalo.Id, jegyek_mentve, [adat1Text, adat2Text, adat3Text]);
        }
    }, [vazlatBetoltve, jegyek_mentve, adat1Text, adat2Text, adat3Text])

    function minden_adat_kitoltve(){
        var kitoltve = true;
        
        if (rendezveny.Adat1kell == 1 && adat1Text == ''){
            kitoltve = false;
        }
        
        if (rendezveny.Adat2kell == 1 && adat2Text == ''){
            kitoltve = false;
        }
        if (rendezveny.Adat3kell == 1 && adat3Text == ''){
            kitoltve = false;
        }
        
        return kitoltve;
    }

    function onChange_adat(adatNumber, event){
        if (adatNumber == 1){
            setAdat1Text(event.currentTarget.value);
        }
        if (adatNumber == 2){
            setAdat2Text(event.currentTarget.value);
        }
        if (adatNumber == 3){
            setAdat3Text(event.currentTarget.value);
        }
        minden_adat_kitoltve()
    }

    function ez_egy_lezart_kifizetett_megrendeles(){
        if (betoltottMegrendelesData != undefined) {
            if (betoltottMegrendelesData.Fizetessikeres == 1){
                return true;
            }else{
                // fizetés sikertelen, újra próbálhatja
                return false;
            }
        }else{
            // folyamatban lévő megrendelés, nincs még mentve
            return false;
        }
    }

    function van_e_eleg_jegy(){
        console.log("Van-e elég jegy: " + jegyek_mentve.length)
        return jegyek_mentve.length > 0
    }

    // A mentett, még nem fizetett megrendelés törlése: csak kifejezett kérésre (a Vissza gomb és a frissítés nem töröl).
    function onClick_megrendeles_torlese(){
        if (props.getCommInProgress()){
            return;
        }
        if (!window.confirm("Valóban törölni szeretné a megkezdett regisztrációt?")){
            return;
        }
        props.callAPI("General.deleteMegrendeles", {megrendelesID: betoltottMegrendelesData.Id}, function(){
            props.frissitFelhasznalo(function(){
                navigate('/rendezvenyek', {replace: true});
            });
        });
    }

    function regisztracio_mentese(onComplete){
        var data = {
            'regiMegrendeles': betoltottMegrendelesData,
            'rendezvenyID': rendezveny.Id,
            'jegyek': jegyek_mentve,
            'adatTextArray': {1: adat1Text, 2: adat2Text, 3: adat3Text},
            'fizetesSikeres': van_e_olyan_mentett_jegy_ami_penzbe_kerul() ? 0 : 1     // ha ingyen van, akkor fizetettre állítjuk
        }
        props.callAPI("General.saveMegrendeles", data, function(resp){
            // a regisztráció mostantól az adatbázisban van: a vázlat felesleges
            vazlatTorles(rendezveny.Id);
            onComplete(resp.data.megrendelesID, resp.data.megrendelesURL)
        }, function(){
            setFizetes_mentes_gomb_helyett_karika(false)
        });
    }

    function onSave_vendegek_vagy_jegyek(ujJegyek){
        setJegyek_mentve(ujJegyek);
    }

    // A számlázási adatok mentése után a szerver a frissített felhasználót adja vissza
    function onSaveSzamlazasiAdatok(ujFelhasznalo){
        setFelhasznalo(ujFelhasznalo)
    }

    // A teljességet a szerver állapítja meg (magánszemély: név, cím; cég: cégnév, adószám, cím); a fizetős
    // megrendelést a szerver a hiányos adattal amúgy sem menti el.
    function szamlazasi_adatok_megvannak(){
        return felhasznalo.szamlazasiAdatokTeljesek === true;
    }

    function van_e_olyan_mentett_jegy_ami_penzbe_kerul(){
        var jegyek_vizsgalni= jegyek_mentve;
        var ar_osszesen = 0;
        for (var i in jegyek_vizsgalni){
            var jegy = jegyek_vizsgalni[i];
            ar_osszesen += jegy.jegyTipus.Arnetto;
        }    
        return (ar_osszesen > 0)
    }

    function onClick_ingyenes_regisztracio_mentese(){
        setFizetes_mentes_gomb_helyett_karika(true)
        let onc = function(megrendeles_id, megrendeles_url){
            // technikai átirányítás (replace): a Vissza gomb ne a már elküldött űrlapra vigyen
            const tovabb = function(){
                props.frissitFelhasznalo(function(){
                    navigate('/megrendeles/' + megrendeles_id, {replace: true});
                });
            };
            props.callAPI("General.sendMegrendelesVisszaigazolasEmail", {megrendelesID: megrendeles_id}, tovabb, tovabb);
        }
        regisztracio_mentese(onc)
    }

    function onClick_btnStripe(){
        regisztracio_mentese(function(megrendeles_id){
            setFizetes_mentes_gomb_helyett_karika(true)
            props.callAPI("General.getStripeURL", {megrendelesID: megrendeles_id}, function(resp){
                window.location = resp.data.stripeURL
            }, function(){
                // a megrendelés már mentve van: a mentett megrendelés oldalán folytatható
                props.frissitFelhasznalo(function(){
                    navigate('/megrendeles/' + megrendeles_id, {replace: true});
                });
            });    
        });
    }


    if (!nevMegvan){
        return (
            <Container className="regisztracio">
                <RegisztracioFejlec felhasznalo={felhasznalo} onKilepes={props.onKilepes} />
                <NevMegadas
                    callAPI={props.callAPI}
                    getCommInProgress={props.getCommInProgress}
                    nev={felhasznalo.Nev}
                    onSave={function(nev){ props.onSetNev(nev); }}
                />
            </Container>
        );
    }
    if (rendezveny == undefined){
        return (<div />);
    }else{
    return (
        <Container className="regisztracio">
            <RegisztracioFejlec felhasznalo={felhasznalo} rendezveny={rendezveny} onKilepes={props.onKilepes} />

{betoltottMegrendelesData != undefined && !ez_egy_lezart_kifizetett_megrendeles() ?
    <div className="megkezdettRegisztracio">
        <div>Ez a regisztráció még <b>nincs befejezve</b>. A férőhelyeket korlátozott ideig tartjuk fenn, ezután a megkezdett regisztráció automatikusan törlődik.</div>
        <Button variant="outline-danger" size="sm" onClick={onClick_megrendeles_torlese}>Megkezdett regisztráció törlése</Button>
    </div>
    : undefined}
{!ez_egy_lezart_kifizetett_megrendeles() ?
<div>
            {rendezveny.Vendegeknevszerint == 1 ? 
                <VendegLista rendezveny={rendezveny} jegyek={jegyek_mentve} onSave={onSave_vendegek_vagy_jegyek.bind(this)} />
                :
                <JegyLista rendezveny={rendezveny} jegyek={jegyek_mentve} onSave={onSave_vendegek_vagy_jegyek} />
            }

                        <br />
                        <hr />
                        {(rendezveny.Adat1kell == 1) ?
                            <div className="utasitas">
                                Adja meg az alábbi adatokat is!
                            </div>
                            :
                            undefined
                        }

                        {(rendezveny.Adat1kell == 1) ?
                            <div className="adatHolder">
                                <div className="adatNev">{rendezveny.Adat1neve}</div>
                                <input type="text" className="input" onChange={onChange_adat.bind(this, 1)} value={adat1Text} />
                                <div className="adatMegjegyzes">{rendezveny.Adat1megjegyzes}</div>
                            </div>
                        :
                            undefined
                        }

                        {(rendezveny.Adat2kell == 1) ?
                            <div className="adatHolder">
                                <div className="adatNev">{rendezveny.Adat2neve}</div>
                                <input type="text" className="input" onChange={onChange_adat.bind(this, 2)} value={adat2Text} />
                                <div className="adatMegjegyzes">{rendezveny.Adat2megjegyzes}</div>
                            </div>
                        :
                            undefined
                        }

                        {(rendezveny.Adat3kell == 1) ?
                            <div className="adatHolder">
                                <div className="adatNev">{rendezveny.Adat3neve}</div>
                                <input type="text" className="input" onChange={onChange_adat.bind(this, 3)} value={adat3Text} />
                                <div className="adatMegjegyzes">{rendezveny.Adat3megjegyzes}</div>
                            </div>
                        :
                            undefined
                        }


            {van_e_olyan_mentett_jegy_ami_penzbe_kerul() ? 
                <div className="regisztracio_inside">
                    {/* -------------------------------------------------------------------------- */}
                    {/* ---------------------------- PÉNZES JEGYEK ------------------------------- */}
                    {/* -------------------------------------------------------------------------- */}
                    <SzamlazasiAdatokDisplay onSave={onSaveSzamlazasiAdatok} felhasznalo={felhasznalo} callAPI={props.callAPI} />
                    
                    {!szamlazasi_adatok_megvannak() ? 
                        <div className="figy_uzenet"><br />A számla kiállításához meg kell adnia a számlázási adatokat!</div>
                    :
                        <div>
                            {!van_e_eleg_jegy() ?
                                undefined // nincs elég jegy
                            :
                            <div>
                                {fizetes_mentes_gomb_helyett_karika ?
                                    <div className="btnStripe"><br />Várjon...</div>
                                :
                                <div className="btnStripe" onClick={onClick_btnStripe}>
                                    <div className="text">Fizetés<br />bankkártyával</div>
                                    <img className="icon" src={"/img/stripe_icon.png?123"} />
                                    
                                </div>
                                }
                            </div>
                            }
                        </div>
                    }
                </div>
                :
                <div>
                    {/* -------------------------------------------------------------------------- */}
                    {/* ---------------------------- INGYENES JEGYEK ----------------------------- */}
                    {/* -------------------------------------------------------------------------- */}
                    <br clear="all" />
                    {(van_e_eleg_jegy() && (minden_adat_kitoltve())) ?
                        <div className="reg_kozepre">
                            {!fizetes_mentes_gomb_helyett_karika ?
                                <div className="reg_kozepre">
                                    <div >Kérjük, tekintse át még egyszer, hogy jól adta-e meg az adatokat!</div>
                                    <div >Ha hibát talál, a <b><i>Vendég törlése</i></b> gombbal javíthatja, a <b><i>Rendezvények</i></b> gombbal visszaléphet (a megadott adatok megmaradnak).</div>
                                    <Button onClick={onClick_ingyenes_regisztracio_mentese.bind(this)}>Elküldöm a regisztrációt</Button>
                                </div>
                            :
                                <div className="reg_kozepre">
                                    Kérjük, várjon...
                                </div>
                            }
                        </div>
                        : undefined
                    }
                </div>
            }
</div>
:
<div>
    nem kiszámlázott, vagy nem kifizetett megrendelés
</div>}
        </Container>
    )
    }
}
